module.exports = __webpack_public_path__ + "static/media/Image_Microsite_Consoles_SE.766d59ea.png";